// @flow
import { constants } from '@clubmed/utils';

import { EVENT_FORM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_EVENT_FORM } from 'Utils/request/requestDictionary';
import { type EventResortProps } from 'Components/lines/event-form-line/EventFormLine.utils';

export const eventFormResolver = {
  name: EVENT_FORM,
  resolve: (appContext: AppContext): Promise<Array<EventResortProps>> => {
    const { PRODUCT_TYPES } = constants;
    const query = `{
      resorts(productType: ${PRODUCT_TYPES.RESORT}) {
        id: resortId
        name
         destination {
          area
        }
      }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_EVENT_FORM,
      strictErrors: false,
    });
  },
};
